import { Link, useLocation, useNavigate } from "react-router-dom";

export default function NavLink({ to, children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = location.pathname.includes(to);

  return (
    <>
      <div
        onClick={() => navigate(to)}
        className={`block py-2 px-3 transition-colors duration-200 text-md text-white cursor-pointer
    ${
      isActive
        ? "text-gray-300 md:text-white border-b-4 border-[#5eafd2] transition-all duration-500 ease-in hover:no-underline hover:text-gray-50 active:text-gray-300"
        : "hover:no-underline hover:text-gray-300"
    }
    rounded md:bg-transparent md:p-0`}
      >
        <span>{children}</span>
      </div>
    </>
  );
}
